<template>
  <div class="d-flex">
    <v-card class="flex-grow-1 covg-card" :class="{ trashed: covg.trashed }">
      <slot />
      <v-card-title class="subtitle-1 d-flex">
        <v-icon
          size="70"
          v-if="covg.trashed"
          color="colorSemanticStateRed100 darken-1"
          class="trash-icon-bg ml-n6"
        >
          mdi-delete
        </v-icon>
        <div class="dual-row my-n3 flex-grow-1">
          <div class="row-one d-flex">
            <div v-if="covg.trashed" class="mr-4 group-trashed">
              Group Trashed
            </div>
            <div v-else class="mr-4">{{ covg.preferredName }}</div>
            <v-spacer />
            <v-tooltip
              top
              v-if="covg.signupCodes && covg.signupCodes.length > 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  small
                  color="colorPtBlue200"
                  class="align-self-center mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="mr-1"><strong>SC</strong></span>
                  <span>{{ covg.signupCodes[0].code }}</span>
                </v-chip>
              </template>
              <span v-if="covg.signupCodes.length > 1">
                <span class="mr-1">All signup codes:</span>
                <span v-for="sc in covg.signupCodes" :key="sc.code">
                  {{ sc.code }}
                </span>
              </span>
              <span v-else>Signup Code</span>
            </v-tooltip>
            <v-chip small color="colorPtBlue200" class="align-self-center">
              <v-icon left>
                mdi-identifier
              </v-icon>
              {{ covg.id }}
            </v-chip>
          </div>
          <div class="row-two d-flex">
            <div class="text--secondary">{{ covg.clientName }}</div>
            <v-spacer />
            <v-tooltip top v-if="covg.vendorCategory">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  label
                  x-small
                  class="mr-4 align-self-center"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ covg.vendorCategory }}
                </v-chip>
              </template>
              <span>Vendor Category</span>
            </v-tooltip>
            <v-tooltip v-if="covg.hasWorkflow" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  size="18"
                  color="colorPtBlue400"
                  class="mr-3"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-format-list-checks
                </v-icon>
              </template>
              <span>This vendor group has a workflow</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  size="18"
                  color="colorPtBlue400"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-timetable
                </v-icon>
              </template>
              <span>
                Created
                {{ covg.createTime | formatDate("MM/dd/yyyy hh:mm:ss a") }} by
                {{ covg.createUser }}
                <br />
                Last modified
                {{ covg.lastModTime | formatDate("MM/dd/yyyy hh:mm:ss a") }} by
                {{ covg.lastModUser }}
                <br v-if="covg.trashed" />
                <span v-if="covg.trashed">
                  Trashed
                  {{ covg.trashTime | formatDate("MM/dd/yyyy hh:mm:ss a") }}
                </span>
              </span>
            </v-tooltip>
          </div>
        </div>
      </v-card-title>
      <div class="pa-4">
        <draggable
          v-if="drag"
          class="cov-group"
          :list="covg.covs"
          v-bind="dragOptions"
          group="covs"
        >
          <ClientOwnedVendor
            v-for="cov in covg.covs"
            :cov="cov"
            :key="cov.id"
            movable
            class="cov-item movable"
          ></ClientOwnedVendor>
        </draggable>
        <ClientOwnedVendor
          v-else
          v-for="cov in covg.covs"
          :cov="cov"
          :key="cov.id"
          class="cov-item"
        ></ClientOwnedVendor>
      </div>
    </v-card>
    <div
      v-if="!showVendor"
      class="vendor-card-minimal"
      :class="{ linked: covg.vendor }"
    ></div>
    <div v-else class="linked-vendor-full d-flex">
      <v-icon
        large
        class="pa-2 mt-2 align-self-baseline"
        v-if="this.covg.vendor"
      >
        mdi-link
      </v-icon>
      <v-icon large class="pa-2 mt-2 align-self-baseline" v-else>
        mdi-link-off
      </v-icon>
      <div class="d-flex">
        <v-card
          v-if="this.covg.vendor"
          class="vendor-card"
          :class="{ trashed: covg.vendor.trashed }"
        >
          <v-card-title class="subtitle-1 d-flex">
            <v-icon
              size="70"
              v-if="covg.vendor.trashed"
              color="colorSemanticStateRed100 darken-1"
              class="trash-icon-bg ml-n6"
            >
              mdi-delete
            </v-icon>
            <div class="mr-4 vendor-name">{{ covg.vendor.legalName }}</div>
            <v-spacer />
            <div class="dual-row my-n2">
              <div class="row-one d-flex justify-end mb-1">
                <v-chip
                  v-if="covg.vendor.ptid"
                  small
                  color="colorVpGreen200"
                  class="mr-2"
                >
                  <span class="mr-1"><strong>PTID</strong></span>
                  <span>{{ covg.vendor.ptid }}</span>
                </v-chip>
                <v-chip small color="colorVpGreen200">
                  <v-icon left>
                    mdi-identifier
                  </v-icon>
                  {{ covg.vendor.id }}
                </v-chip>
              </div>
              <div class="row-two d-flex justify-end">
                <div class="mr-4 my-n1 text--primary">
                  {{ covg.vendor.tin | formatTIN(covg.vendor.tinType) }}
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      size="18"
                      color="colorVpGreen400"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-timetable
                    </v-icon>
                  </template>
                  <span>
                    Created
                    {{
                      covg.vendor.createTime
                        | formatDate("MM/dd/yyyy hh:mm:ss a")
                    }}
                    by
                    {{ covg.vendor.createUser }}
                    <br />
                    Last modified
                    {{
                      covg.vendor.lastModTime
                        | formatDate("MM/dd/yyyy hh:mm:ss a")
                    }}
                    by
                    {{ covg.vendor.lastModUser }}
                    <br v-if="covg.vendor.trashed" />
                    <span v-if="covg.vendor.trashed">
                      Trashed
                      {{
                        covg.vendor.trashTime
                          | formatDate("MM/dd/yyyy hh:mm:ss a")
                      }}
                    </span>
                  </span>
                </v-tooltip>
              </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-else class="vendor-card d-flex" color="#F8F8F8">
          <v-card-text class="text-center">
            No Vendor Linked
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import ClientOwnedVendor from "@/views/admin/ClientOwnedVendor.vue";
import draggable from "vuedraggable";
import { formatDate, formatTIN } from "@/services/format";

export default {
  name: "ClientOwnedVendorGroup",
  components: { ClientOwnedVendor, draggable },
  props: {
    covg: {},
    showVendor: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    dragOptions() {
      return {
        animation: 400,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  filters: {
    formatDate,
    formatTIN
  }
};
</script>

<style scoped lang="scss">
.ghost {
  opacity: 0.3;
}

.cov-item {
  border: 1px solid $color-neutrals-navy-50;
  margin-top: -1px;

  &.movable {
    border-color: $color-neutrals-navy-150;
    cursor: move;
  }
}

.cov-group {
  min-height: 50px;
}

.covg-card {
  .v-card__title {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: $color-pt-blue-100;
  }

  &.trashed .v-card__title {
    background-image: linear-gradient(
      to right,
      $color-semantic-state-red-100 20%,
      $color-pt-blue-100 60%
    );

    .trash-icon-bg {
      position: absolute;
      z-index: 0;
    }

    .dual-row {
      z-index: 1;
    }
  }
}

.vendor-card {
  min-width: 350px;
  height: 64px;

  .v-card__title {
    background-color: $color-vp-green-100;
    height: 64px;
  }

  &.trashed .v-card__title {
    background-image: linear-gradient(
      to right,
      $color-semantic-state-red-100 20%,
      $color-vp-green-100 60%
    );

    .trash-icon-bg {
      position: absolute;
      z-index: 0;
    }

    .vendor-name {
      z-index: 1;
    }
  }
}

.vendor-card-minimal {
  width: 15px;
  height: 64px;
  background-image: linear-gradient(
    to right,
    white,
    $color-neutrals-navy-50 60%
  );
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  &.linked {
    background-image: linear-gradient(to right, white, $color-vp-green-100 60%);
  }
}
</style>
